import { render, staticRenderFns } from "./QuoteDistributionComponent.vue?vue&type=template&id=00834408&scoped=true&"
import script from "./QuoteDistributionComponent.vue?vue&type=script&lang=js&"
export * from "./QuoteDistributionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00834408",
  null
  
)

export default component.exports